import { CHALLENGES, loginTypes } from './data/enums';

export const getGoogleAuthButtonConfig = ({ locale, width, handleClickListener }) => ({
  type: 'standard',
  size: 'large',
  theme: 'outline',
  locale: locale?.split('-')[0],
  shape: 'rectangular',
  logo_alignment: 'left',
  width,
  text: 'signin_with',
  click_listener: handleClickListener,
});

export const isSocialLogin = (type) => type === CHALLENGES.email_or_nickname_or_phone_or_social_login || type === CHALLENGES.email_or_nickname_or_phone_or_social_login_with_recaptcha;

export const isSocialGoogleExternalLogin = (loginType) => loginType === loginTypes.SOCIAL_GOOGLE_EXTERNAL;

const ALLOWED_SOCIAL_CONTEXTUALS = ['homes-palpatine', 'vpp-frontend', 'search-nordic'];
export const validateSocialContextualParam = (value) => ALLOWED_SOCIAL_CONTEXTUALS.includes(value) ? value : 'unknown';
